export default __webpack_public_path__ + "static/advance-application-064f0aabc0ab53ea4c069dc0973da8f8.jpg";